import { convertMorganToOlsen, convertOlsenToMorgan, getMorganAttribute, getMorganIndexTextFromValue, isNumber, react, soil, SoilUnit } from "../../../omnia"

interface Props {

    value: number

    attr: string

    unit: SoilUnit

    /** Indicates if the value is expressed in Morgan mg/l, or Olsen ppm */
    morgan?: boolean

}

export function AnalysisValueGauge({ value, unit, attr, morgan }: Props) {

    if (!isNumber(value)) {
        return null
    }

    const morganAttr = getMorganAttribute(attr)

    const index = unit === SoilUnit.Index

    const gaugeValue = morgan && morganAttr
        ? convertMorganToOlsen(morganAttr, value)
        : value

    const style = react.convertStyle(soil.colors.getGaugeStyle(gaugeValue, attr))

    let displayedValue: string | number = value

    // Indices requested + value expressed in Morgan mg/l + this is a Morgan attribute
    // -> display a Morgan index
    if (index && morgan && morganAttr) {
        displayedValue = getMorganIndexTextFromValue(morganAttr, value)
    }
    // Indices requested + value expressed not expressed in Morgan mg/l
    // -> display an Olsen index
    else if (index) {
        displayedValue = soil.colors.getValueIndex(value, attr)
    }
    // Olsen ppm requested + value expressed in Morgan mg/l + this is a Morgan attribute
    // -> convert from Morgan to Olsen
    else if (morgan && morganAttr && (unit === SoilUnit.Ppm)) {
        displayedValue = convertMorganToOlsen(morganAttr, value)
    }
    // Conversely, Morgan mg/l requested + value expressed in Olsen ppm
    // -> convert from Olsen to Morgan
    else if ((!morgan) && morganAttr && (unit === SoilUnit.Morgan)) {
        displayedValue = convertOlsenToMorgan(morganAttr, value)
    }

    return <>

        <div className="gauge-container">
            <div></div>
            <div></div>
            <div style={style}>
            </div>
            <div>
                <span>{displayedValue}</span>
            </div>
        </div>

    </>
}
